import { Injectable } from '@angular/core';
import {AppSettings} from "../../proyect.conf";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {RequisitosGarantiasRespaldosTiposPersonas} from "../_models/requisitos-garantias-respaldos-tipos-personas";

@Injectable({
  providedIn: 'root'
})
export class RequisitosGarantiasRespaldosTiposPersonasService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasRespaldosTiposPersonas';

  constructor(private httClient: HttpClient) { }

  listado() {
    return this.httClient.get(this.rutServicio).pipe(map(res => res as RequisitosGarantiasRespaldosTiposPersonas[]));
  }

  busquedaRequisitoGarantiaRespaldo(idRequisitoGarantiaRespaldo: string) {
    return this.httClient.get(this.rutServicio + '/idRequisitoGarantiaRespaldo/' + idRequisitoGarantiaRespaldo + '/enabled').pipe(map(res => res as RequisitosGarantiasRespaldosTiposPersonas[]));
  }

  bulk( registros: RequisitosGarantiasRespaldosTiposPersonas[] ) {
    return this.httClient.post( `${this.rutServicio}/bulk`, registros ).pipe( map( res => res as any ) );
  }
}
